<template>
   <div>
      <BaseLayout />
   </div>
   <BaseDialog v-model:open-dialog="isFeedbackVisible" size="sm" preserve-log>
      <template #header></template>
      <VideoCallClientFeedback
         @close="closePendingFeedback"
         @success="checkIsPendingClientFeedback"
         :data="clientInformation?.pending_booking"
         :is-pending="true"
      ></VideoCallClientFeedback>
   </BaseDialog>
   <BaseDialog
      v-model:open-dialog="isSurveyVisible"
      title=""
      preserve-log
      :is-mobile-full-width="true"
      :no-padding="true"
   >
      <ClientSurveyDialog @close="isOpenSurvey = false"></ClientSurveyDialog>
   </BaseDialog>
</template>

<script setup lang="ts">
   const isPendingClientFeedback = ref(false);
   const isOpenSurvey = ref(false);
   const layoutReady = ref(false);
   const { state: promptState, setBlocker } = useClientMobileAppPrompt();
   const optionalDialogsAllowed = computed(
      () =>
         !promptState.value.emergencyPending &&
         !promptState.value.showAppPrompt &&
         !promptState.value.showWelcome,
   );
   const isFeedbackVisible = computed({
      get: () => isPendingClientFeedback.value && optionalDialogsAllowed.value,
      set: (open: boolean) => {
         isPendingClientFeedback.value = open;
      },
   });
   const isSurveyVisible = computed({
      get: () => isOpenSurvey.value && optionalDialogsAllowed.value,
      set: (open: boolean) => {
         isOpenSurvey.value = open;
      },
   });
   watch(
      [layoutReady, isPendingClientFeedback, isOpenSurvey],
      () =>
         setBlocker(
            'client-layout',
            !layoutReady.value || isPendingClientFeedback.value || isOpenSurvey.value,
         ),
      { immediate: true, flush: 'sync' },
   );
   onUnmounted(() => setBlocker('client-layout', false));
   import { usePusherStore } from '@/stores/pusher.pinia';

   const { connectToPusher } = usePusherStore();
   const { clientInformation } = storeToRefs(useClientInfo());
   const isPendingClientEmergencyContact = ref(true);
   const checkIsPendingClientFeedback = () => {
      if (clientInformation?.value?.pending_booking) {
         isPendingClientFeedback.value = true;
      } else {
         checkIfIsSurvey();
      }
   };
   const checkIfIsSurvey = () => {
      if (clientInformation?.value?.client?.has_survey) {
         isOpenSurvey.value = true;
      }
   };
   const closePendingFeedback = () => {
      isPendingClientFeedback.value = false;
      checkIfIsSurvey();
   };
   onMounted(() => {
      connectToPusher(true);
      checkIsPendingClientFeedback();
      layoutReady.value = true;
   });
</script>
